import { createReducer, on } from '@ngrx/store';
import { HubState, initialState } from './hub.state';
import * as actions from './index';
import { routerNavigatedAction } from '@ngrx/router-store';

export const HubReducer = createReducer<HubState>(
  initialState,

  // Handle the router navigation action to update the current route
  on(routerNavigatedAction, (state, action): HubState => {
    return {
      ...state,
      currentRoute: action.payload.event.urlAfterRedirects
    };
  }),

  on(actions.HubActions.appInit, (): HubState => {
    return {
      ...initialState,
      loading: true
    };
  }),

  on(actions.HubActions.userDataSuccess, (state, action): HubState => {
    return {
      ...state,
      userData: {
        uid: action.result.uid,
        firstName: action.result.firstName,
        lastName: action.result.lastName,
        isSupportUser: action.result.isSupportUser,
        isDeveloper: action.result.isDeveloper,
        isSalesUser: action.result.isSalesUser
      },
      userSettings: {
        id: action.result.hubUserSettings.id,
        userId: action.result.hubUserSettings.userId,
        darkMode: action.result.hubUserSettings.darkMode,
        searchField: action.result.hubUserSettings.searchField
          ? action.result.hubUserSettings.searchField
          : initialState.userSettings.searchField
      },
      loading: false
    };
  }),

  on(actions.HubActions.userDataFailure, (state, action): HubState => {
    return {
      ...initialState,
      loading: false,
      error: action.error
    };
  }),

  on(actions.HubActions.countryListSuccess, (state, action): HubState => {
    // put priority countries first (keeping the order from `priority`)
    const priority = ['United Kingdom', 'United States', 'Australia'];

    const sorted = [
      ...priority
        .map((priority) => action.result.find((country) => country.name === priority))
        .filter((country): country is { id: number; name: string } => !!country),
      ...action.result.filter((country) => !priority.includes(country.name))
    ];

    return {
      ...state,
      countryList: sorted
    };
  })
);
